import React, { useState, useEffect } from "react";
import { connect } from 'react-redux';
import { Actions as ACTIONS } from '../../store/actions/workLocationActions';

import ReactDOM from "react-dom";
// import axios from 'axios';
import Select from 'react-select';
import _ from 'lodash';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import 'react-notifications/lib/notifications.css';
import { format, setHours, setMinutes, setSeconds, setDate, differenceInDays, differenceInMinutes } from 'date-fns'
import { XMarkIcon } from '@heroicons/react/20/solid'
import Spinner from '../common/Spinner'

const CancelWorkLocationModal = ({
  mode,
  workLocation,
  workLocationType,
  showCancelWorkLocation,
  workLocationStatus,

  modalSaving,
  currentWorkLocation,
  saveWorkLocation,
  // mySaveWorkLocation
}) => {

  const [comment, setComment] = useState();

  if (!workLocation) {
    return null;
  }

  const saveWorkLocationData = () => {

    const workLocationData = {
      id: workLocation.id,
      comment: comment,
      agreement: workLocation.agreementID || workLocation.agreementId,
      status: workLocationStatus,
    }

    saveWorkLocation(workLocationData);
    showCancelWorkLocation(null, null);
    setComment(null)
  }

  return (
    <div className="modal" tabindex="-1" role="dialog" aria-hidden="true" style={{ display: "block", background: "rgba(0,0,0,0.4)" }}>
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="block block-themed block-transparent remove-margin-b">
            <div className="block-header bg-danger">
              <ul className="block-options">
                <li>
                  <button type="button" onClick={() => { showCancelWorkLocation(null, null) }}>
                    <XMarkIcon className="h-6 w-6 mr-3 text-white" />
                  </button>
                </li>
              </ul>
              <h3 className="block-title">{workLocationStatus && workLocationStatus == "Denied" ? 'Deny' : 'Cancel'} {workLocationType} Work Location starting {format(new Date(workLocation.date), "do MMM yyyy")}</h3>
            </div>
            <div className="block-content">

              <div className="form-group">
                <div className="col-sm-12">
                  <label>Add Comment</label>
                  <textarea
                    className="form-control"
                    type="text"
                    name="comment"
                    style={{ minHeight: 100, maxHeight: 400, resize: "vertical" }}
                    onChange={(e) => {
                      setComment(e.target.value)
                    }}
                  >{comment}</textarea>
                  <div className="clearfix"></div>
                </div>
                <div className="clearfix"></div>
              </div>

              {!modalSaving &&
                <button className="btn btn-danger pull-right" onClick={() => saveWorkLocationData()} style={{ marginRight: 0, marginBottom: "20px" }}>Deny Request</button>
              }

              {
                modalSaving &&
                <button className="btn btn-success pull-right" style={{ marginRight: 0 }}>
                  <Spinner
                    style={{ height: "1.5em", verticalAlign: 'middle', float: "left" }}
                    className="animate-spin -ml-1 mr-3 h-5 w-5 "
                  />
                  <div style={{float: 'left'}}>Saving</div>
                </button>
              }
              <div className="clearfix"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = (state) => {

  const {
    // workLocation,
    workLocationTypes,
  } = state.workLocation



  const workLocation = state.workLocation.showCancelWorkLocation;
  const workLocationStatus = state.workLocation.showCancelWorkLocationStatus;

  return {
    // ...state.my,
    mode: state.mode,
    modalSaving: state.workLocation.modalSaving,
    workLocation,
    workLocationStatus,
    workLocationType: workLocationTypes && workLocation && _.find(workLocationTypes, { id: workLocation.type }).name,

  }
}

const mapDispatchToProps = dispatch => ({
  showCancelWorkLocation: (workLocation, status) => dispatch(ACTIONS.showCancelWorkLocation(workLocation, status)),
  saveWorkLocation: (workLocation) => dispatch(ACTIONS.saveWorkLocation(workLocation)),
  // mySaveWorkLocation: (timesheet) => dispatch(MYACTIONS.mySaveWorkLocation(timesheet)),
  // timesheetUpdateSaveStatus: (status) => dispatch(ACTIONS.timesheetUpdateSaveStatus(status))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CancelWorkLocationModal) 
